// extracted by mini-css-extract-plugin
export var active = "_hc-2";
export var recordingDot = "_hc-1";
export var recordingIndicator = "_hc-0";